import {
    hideModal,
    resetButtonState,
    setButtonLoading,
} from '../core/bootstrap-helpers.js';

export function normalizeOrderingMode(mode) {
    return mode === 'simple' ? 'simple' : 'multi';
}

export function getOrderingModeLabel(mode) {
    return normalizeOrderingMode(mode) === 'simple'
        ? 'Single Ordering'
        : 'Multi Ordering';
}

export function clearOrderingModeReloadTimer($modal) {
    var reloadTimer = $modal.data('ordering-mode-reload-timer');

    if (reloadTimer) {
        clearTimeout(reloadTimer);
        $modal.removeData('ordering-mode-reload-timer');
    }
}

export function setOrderingModeStatus($modal, type, message) {
    var $status = $modal.find('[data-ordering-mode-status]');

    $status.removeClass('d-none is-success is-error is-info');
    $status
        .addClass('is-' + type)
        .find('.ordering-mode-status__message')
        .text(message);
}

export function clearOrderingModeStatus($modal) {
    var $status = $modal.find('[data-ordering-mode-status]');

    $status.addClass('d-none').removeClass('is-success is-error is-info');
    $status.find('.ordering-mode-status__message').empty();
}

export function setOrderingModeSaveDisabled($modal, disabled) {
    var $saveButton = $modal.find('[data-ordering-mode-save]');

    $saveButton.prop('disabled', disabled);

    if (disabled) {
        $saveButton.attr('disabled', 'disabled');
        return;
    }

    $saveButton.removeAttr('disabled');
}

export function updateOrderingModeModalState($modal, selectedMode) {
    var currentMode = normalizeOrderingMode($modal.attr('data-current-mode'));
    var isSaving = $modal.attr('data-ordering-mode-saving') === 'true';

    selectedMode = normalizeOrderingMode(selectedMode || currentMode);

    $modal.attr('data-selected-mode', selectedMode);

    $modal.find('[data-ordering-mode-option]').each(function () {
        var $option = $(this);
        var optionMode = normalizeOrderingMode(
            $option.attr('data-ordering-mode-option')
        );
        var isSelected = optionMode === selectedMode;
        var isCurrent = optionMode === currentMode;

        $option.toggleClass('is-selected', isSelected);
        $option.toggleClass('is-current', isCurrent);
        $option.attr('aria-pressed', isSelected ? 'true' : 'false');
        $option.prop('disabled', isSaving);
    });

    setOrderingModeSaveDisabled($modal, isSaving);
}

export function initOrderingModeModal() {
    var $orderingModeModal = $('#orderingModeModal');

    if (!$orderingModeModal.length) {
        return;
    }

    function resetOrderingModeModal() {
        clearOrderingModeReloadTimer($orderingModeModal);
        $orderingModeModal.attr('data-ordering-mode-saving', 'false');
        clearOrderingModeStatus($orderingModeModal);
        updateOrderingModeModalState(
            $orderingModeModal,
            $orderingModeModal.attr('data-current-mode')
        );
        resetButtonState($orderingModeModal.find('[data-ordering-mode-save]'));
    }

    resetOrderingModeModal();

    $orderingModeModal.on('show.bs.modal', function () {
        resetOrderingModeModal();
    });

    $orderingModeModal.on('hidden.bs.modal', function () {
        if ($orderingModeModal.attr('data-ordering-mode-saving') !== 'true') {
            resetOrderingModeModal();
        }
    });

    $orderingModeModal.on('click', '[data-ordering-mode-option]', function () {
        if ($orderingModeModal.attr('data-ordering-mode-saving') === 'true') {
            return;
        }

        clearOrderingModeStatus($orderingModeModal);
        updateOrderingModeModalState(
            $orderingModeModal,
            $(this).attr('data-ordering-mode-option')
        );
    });

    $orderingModeModal.on('click', '[data-ordering-mode-save]', function () {
        var $saveButton = $(this);
        var selectedMode = normalizeOrderingMode(
            $orderingModeModal.attr('data-selected-mode')
        );
        var currentMode = normalizeOrderingMode(
            $orderingModeModal.attr('data-current-mode')
        );

        if (selectedMode === currentMode) {
            hideModal($orderingModeModal);
            return;
        }

        $orderingModeModal.attr('data-ordering-mode-saving', 'true');
        updateOrderingModeModalState($orderingModeModal, selectedMode);
        setOrderingModeStatus(
            $orderingModeModal,
            'info',
            'Saving your ordering preference...'
        );
        setButtonLoading($saveButton, 'Saving...');

        $.ajax({
            url: '/account/set_order_method',
            type: 'post',
            dataType: 'json',
            data: { order_method: selectedMode },
            success: function (response) {
                var responseSuccess =
                    response === true ||
                    response === 1 ||
                    response === '1' ||
                    (response &&
                        typeof response === 'object' &&
                        response.success === true);
                var persistedMode =
                    response &&
                    typeof response === 'object' &&
                    response.current_mode
                        ? normalizeOrderingMode(response.current_mode)
                        : selectedMode;

                if (responseSuccess && persistedMode === selectedMode) {
                    $orderingModeModal.attr(
                        'data-current-mode',
                        persistedMode
                    );
                    updateOrderingModeModalState(
                        $orderingModeModal,
                        persistedMode
                    );
                    setOrderingModeStatus(
                        $orderingModeModal,
                        'success',
                        getOrderingModeLabel(persistedMode) +
                            ' is now active. Reloading to apply your change...'
                    );

                    hideModal($orderingModeModal);

                    $orderingModeModal.data(
                        'ordering-mode-reload-timer',
                        setTimeout(function () {
                            window.location.reload();
                        }, 900)
                    );

                    return;
                }

                $orderingModeModal.attr('data-ordering-mode-saving', 'false');
                resetButtonState($saveButton);
                updateOrderingModeModalState(
                    $orderingModeModal,
                    selectedMode
                );
                setOrderingModeStatus(
                    $orderingModeModal,
                    'error',
                    response &&
                        typeof response === 'object' &&
                        response.current_mode &&
                        persistedMode !== selectedMode
                        ? 'The server kept ' +
                              getOrderingModeLabel(persistedMode) +
                              ' active. Please try again.'
                        : 'We could not save your ordering preference. Please try again.'
                );
            },
            error: function () {
                $orderingModeModal.attr('data-ordering-mode-saving', 'false');
                resetButtonState($saveButton);
                updateOrderingModeModalState(
                    $orderingModeModal,
                    selectedMode
                );
                setOrderingModeStatus(
                    $orderingModeModal,
                    'error',
                    'We could not save your ordering preference. Please check your connection and try again.'
                );
            },
        });
    });
}
